import { makeStyles } from '@material-ui/core'

export default makeStyles(() => ({
  previewBoxContainer: {
    minHeight: '700px',
    maxHeight: '700px',
    overflowY: 'auto',
    position: 'relative',
  },
  previewBox: {
    fontSize: '16px',
    fontFamily: 'Arial, sans-serif !important',
    lineHeight: 1.5,

    '& *': {
      fontFamily: 'Arial, sans-serif !important',
      color: 'initial',
    },
  },
}))
